import AddCentro from 'components/centros/AddCentro'
import React from 'react'
import { Card, Col, Row } from 'reactstrap'

const ViewAddCentro = () => {
  return (
    <>
      <Card>
        <Row>
              <Col>
                <AddCentro></AddCentro>
              </Col>
          </Row>


      </Card>
        

    </>
  )
}

export default ViewAddCentro